export default __webpack_public_path__ + "static/media/logo-rebrand.919ba048.svg";